module.exports = __webpack_public_path__ + "img/plan3.1b1313be.png";